import React from "react";
import AcxInputLabel from "./AcxInputLabel";

type Props = {
    errors?: string | string[];
};

const AcxErrorMessage: React.FC<
    React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ errors }) => {
    if (!errors) {
        return <></>;
    }

    return (
        <AcxInputLabel
            id={"AcxText-BottomLabel"}
            showAllErrors={true}
            sx={[
                (theme) => ({
                    fontFamily: theme.typography.fontFamily,
                    color: `${theme.palette.error.main} !important`,
                    fontSize: "12px",
                    lineHeight: "16px",
                }),
            ]}
        >
            {Array.isArray(errors)
                ? errors.join("\n")
                : typeof errors === "string"
                ? errors
                : JSON.stringify(errors)}
        </AcxInputLabel>
    );
};

export default AcxErrorMessage;
